
<template>
<div class="tabbed-content" :class="{disabled : (user.user_role === 'charity')}">
  <div class="columns">
    <div class="col">
      <chc-input v-model="data.first_name" :error="errors.first_name" label="First Name" :required="true"></chc-input>
      <chc-input v-model="data.last_name" :error="errors.last_name" label="Last Name" :required="true"></chc-input>
      <chc-input v-model="data.caller_name" :error="errors.caller_name" label="Caller Name (if different)"></chc-input>
      <chc-input v-model="data.home_phone" :error="errors.home_phone" label="Home Phone Number"></chc-input>
      <chc-input v-model="data.work_phone" :error="errors.work_phone" label="Work Phone Number"></chc-input>
      <chc-input v-model="data.mobile_phone" :error="errors.mobile_phone" label="Mobile Phone Number"></chc-input>
      <chc-input v-model="data.email" :error="errors.email" label="Email Address"></chc-input>
      <chc-input v-model="data.ssn_tax_id" :error="errors.ssn_tax_id" label="Social Security Number / Tax ID"
                 v-if="user.user_role === 'admin'"></chc-input>
      <chc-input v-model="data.year_of_birth" :error="errors.year_of_birth" label="Year of Birth"
                 v-if="user.user_role === 'admin'"></chc-input>
      <chc-input v-model="data.charity_id" :error="errors.charity_id" label="Select Charity"
                 @input="reloadSources" :autoCompleteValuesHidden="$store.state.summary.charities"
                 :autoCompleteValues="$store.state.summary.charities_active" format="combo" :required="true"
                 v-if="user.user_role !== 'charity'"></chc-input>
      <chc-input v-model="data.referral_source_id" :error="errors.referral_source_id" label="Referral Source"
                 :loading="isLoadingSources" :disabled="sources.length === 0"
                 :autoCompleteValues="sources" format="combo" ref="referralSourceCombo"></chc-input>
    </div>
    <div class="col">
      <h3>Mailing Address</h3>
      <chc-input v-model="data.address_street" :error="errors.address_street" label="Street Address"></chc-input>
      <chc-input v-model="data.address_city" :error="errors.address_city" label="City"></chc-input>
      <chc-input v-model="data.address_state" :error="errors.address_state" label="State" format="combo"
                 :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
      <chc-input v-model="data.address_zip" :error="errors.address_zip" label="Zip" format="zip"></chc-input>
      <chc-checkbox v-model="data.towing_address_different" label="Different Towing Address than Mailing Address"></chc-checkbox>
      <h3 v-if="data.towing_address_different">Towing Address</h3>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_business_name" :error="errors.towing_business_name" label="Business Name"></chc-input>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_contact_name" :error="errors.towing_contact_name" label="Contact Name"></chc-input>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_contact_phone" :error="errors.towing_contact_phone" label="Contact Phone"></chc-input>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_address_street" :error="errors.towing_address_street" label="Street Address"></chc-input>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_address_city" :error="errors.towing_address_city" label="City"></chc-input>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_address_state" :error="errors.towing_address_state" label="State" format="combo"
                 :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
      <chc-input v-if="data.towing_address_different" v-model="data.towing_address_zip" :error="errors.towing_address_zip" label="Zip" format="zip"></chc-input>
    </div>
  </div>
  <div class="columns" v-if="user.user_role != 'charity'">
    <div class="col">
      <span v-if="hasErrors" class="error-message error-block">
        There were errors processing the form. Please fix the fields above.
      </span>
      <div class="field buttons submit-section">
        <input @click="submit" class="btn" value="Save Changes" type="submit">
      </div>
      <transition name="fade">
        <p v-if="saved" class="success-message">Changes Saved</p>
      </transition>
      <p></p>
    </div>
  </div>
</div>
</template>

<script>
import store from '@/store'
import auth from '@/auth'

export default {
  name: 'VehicleDonorInfo',
  data () {
    return {
      user: auth.user,
      errors: {
      },
      isLoadingSources: false,
      sources: [],
      hasErrors: false,
      saved: false,
      initial: true,
    }
  },
  props: ['vehicleId', 'data', 'hasSource'],
  methods: {
    submit () {
      this.saved = false
      store.functions.vehicles.editVehicleDonorInfo(this.vehicleId, this.data, (errors) => {
        this.errors = errors
        this.hasErrors = true
        this.saved = false
      }).then(() => {
        this.$toast.success('Changes saved.')
        this.hasErrors = false
        this.errors = {}
        this.saved = true
        this.$emit('refresh')
        setTimeout(() => {
          this.saved = false
        }, 500)
      }).catch(() => {
        this.$toast.error('Failed to save information...')
      })
    },
    reloadSources (id) {
      if (isNaN(id)) return
      this.isLoadingSources = true
      if (this.initial) {
        this.initial = false
      } else this.$refs.referralSourceCombo.select({label: null, value: null})
      store.functions.charity.getSources(id, (errors) => {
      }).then(response => {
        this.sources = response.data
      }).catch(() => {
      }).finally(() => {
        if (this.data.referral_source_id) {
          for (var i = this.sources.length - 1; i >= 0; i--) {
            if (this.sources[i].value === this.data.referral_source_id) {
              this.$refs.referralSourceCombo.select(this.sources[i])
              break
            }
          }
        }
        this.isLoadingSources = false
        this.data.charitySelected = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}
.col h3:first-child {
  margin-top: 0;
}

.disabled div {
    pointer-events: none;
    user-select: none;
}
.disabled div div {
  pointer-events: none;
  user-select: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehicleDonorInfo.vue